import React, { useEffect } from "react";
import { IoClose } from "react-icons/io5";

interface SmartCameraComponentProps {
  setIsImageCaptured: React.Dispatch<React.SetStateAction<boolean>>;
  setSubmit: React.Dispatch<React.SetStateAction<number>>;
  setPartnerParams: any;
  setImages: any;
}

const SmartCameraComponent: React.FC<SmartCameraComponentProps> = ({
  setIsImageCaptured,
  setSubmit,
  setPartnerParams,
  setImages,
}) => {
  useEffect(() => {
    const handleImagesComputed = async (e: Event) => {
      const customEvent = e as CustomEvent;

      const { partner_params, images } = customEvent.detail;
      setPartnerParams(partner_params.libraryVersion);

      setImages(images);
      // Update the state to indicate that the image has been captured
      setIsImageCaptured(false);
      setSubmit(1);
    };

    const app = document.querySelector("smart-camera-web");
    if (app) {
      app.addEventListener(
        "imagesComputed",
        handleImagesComputed as EventListener
      );
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (app) {
        app.removeEventListener(
          "imagesComputed",
          handleImagesComputed as EventListener
        );
      }
    };
  }, [setIsImageCaptured]);

  return (
    <div className="fixed inset-0 flex font-manrope justify-center items-start pt-16 pb-16 overflow-auto bg-white dark:bg-[#141414]   backdrop-blur-sm">
      <div className=" w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 ">
        <div className="flex justify-end">
          <IoClose
            onClick={() => setIsImageCaptured(false)}
            className="text-paragraph text-[24px] dark:text-white cursor-pointer"
          />
        </div>
        <smart-camera-web></smart-camera-web>
      </div>
    </div>
  );
};

export default SmartCameraComponent;
